import React from "react";

export const ErrorsLog = ({ mainError = null, errors = [] }) => {
    const getTextError = (error) => {
        let errorText = ''

        if(error && error.code !== null && error.message) errorText = error.code + ' - ' + error.message
        if(error && error.code === null && error.message) errorText = error.message
        if(error && error.code !== null && !error.message) errorText = error.code
        
        return errorText
    }
    return (
        <div className="content-errors-log">
            <i className="material-icons color-red" >error</i>
            {!mainError && <span>Error</span>}
            {mainError && <span>Error: {`${getTextError(mainError)}`} </span>}
            <br />

            {errors && errors.map(error => {
                if(mainError !== error) {
                    return (
                        <>
                            <br />
                            <span>{getTextError(error)}</span>
                        </>
                    )
                }
            })}
        </div>
    )
}